module.exports = {
  contentTypes: [
    {
      type: "STREAM",
      name: "Streams",
      description:
        "Create your own content streams. Organize your team's work into collaborative groups that make tracking easier than following The Office's drama",
    },
    {
      type: "COLLECTION",
      name: "Collections",
      description:
        "Create a dedicated section to showcase your best collections. Because sharing curated content beats sending 47 separate links.",
    },
    {
      type: "ASSET",
      name: "Assets",
      description:
        "Showcase individual assets directly. Highlight your content team's greatest hits, one piece at a time.",
    },
  ],
};
